// extracted by mini-css-extract-plugin
module.exports = {"collapse":"SupportQuestion_collapse__TfKjO","collapseHeader":"SupportQuestion_collapseHeader__13wo7","collapseContent":"SupportQuestion_collapseContent__KPzgp"};